<template>
  <div v-if="hasLoad" class="order-list-page">
    <template v-if="configList.length > 0">
      <van-notice-bar
        v-if="noticeTip"
        wrapable
        :scrollable="false"
        :color="noticeColor"
        :text="noticeTip"
        :background="noticeBgColor"
        left-icon="volume"
      />
      <div class="config-content">
        <div
          v-for="(config, index) in configList"
          :key="index"
          class="config-item"
        >
          <div class="config-title">
            <div class="config-name">{{ config.name }}</div>
            <div class="config-desc">{{ config.desc }}</div>
          </div>
          <div class="item-wrapper">
            <div v-for="item in config.items" :key="item.key" class="item-info">
              <div class="item-name">{{ item.name }}</div>
              <div class="candidate-wrapper">
                <div
                  v-for="candidate in item.candidates"
                  :key="candidate.value"
                  class="candidate-item"
                >
                  <div
                    class="select-operate"
                    @click="selectItem(candidate, item)"
                  >
                    <IconFont
                      :name="
                        candidate.selected
                          ? 'xuankuang-gouxuan'
                          : 'xuankuang-weixuanzhong'
                      "
                      :color="candidate.selected ? '#15bb5c' : '#ccc'"
                      size="24px"
                    ></IconFont>
                  </div>
                  <div class="label">{{ candidate.label }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <empty
      v-if="configList.length === 0"
      :desc="'配送单设置'"
      :type="1"
      :img="'Empty'"
      class="empty-box"
    ></empty>
  </div>
</template>
<script>
import { navBar } from '@/utils/native_interactions/native_bar'
import themeMixin from '@/common/mixins/theme'
import Empty from '@/common/layout/empty/index'
import { API } from '@/api'
export default {
  components: { Empty },
  mixins: [themeMixin],
  beforeRouteEnter(to, from, next) {
    next(vm => {
      document.title = '配送单设置'
      navBar.setTitle({
        text: '配送单设置'
      })
      vm.$Loading()
      vm.getConfig()
    })
  },
  data() {
    return {
      configList: [],
      hasLoad: true,
      noticeTip: '以下设置以门店维度生效',
      noticeBgColor: '#FFE7D9',
      noticeColor: '#FF5C00'
    }
  },
  methods: {
    async getConfig() {
      try {
        this.hasLoad = true

        const res = await API.account.userConfig({ type: 1 })
        this.configList = res
        this.$Loading.hide()
      } catch (e) {
        this.$catch(e)
        this.hasLoad = true
        this.configList = []
        this.$Loading.hide()
      }
    },
    async selectItem(candidate, item) {
      try {
        this.$Loading()
        await API.account.submitConfig({
          key: item.key,
          value: candidate.value
        })
        this.$Loading.hide()
        this.$toast('保存成功')
        this.getConfig()
      } catch (e) {
        this.$catch(e)
        this.$Loading.hide()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.order-list-page {
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #f5f5f5;
  .config-content {
    flex: auto;
    height: 0;
    overflow: auto;
    @include iphonex-padding-bottom(30px);
    .config-item {
      .config-title {
        padding: 12px;
        .config-name {
          @include text(0.32rem /* 16/50 */, #262626, true);
        }
        .config-desc {
          margin-top: 2px;
          @include text(0.28rem /* 14/50 */, #8c8c8c);
        }
      }
      .item-wrapper {
        padding: 0 16px;
        background-color: #fff;
      }
      .item-info {
        padding: 10px 0;
        @include flex-row-between;
        @include text(0.28rem /* 14/50 */, #262626);
        border-top: 1px solid #f5f5f5;
        &:first-child {
          border-top: none;
        }

        .candidate-wrapper {
          @include flex-row-center;
          .candidate-item {
            @include flex-row-center;
            margin-left: 30px;
            &:first-child {
              margin-left: 0;
            }
          }
          .label {
            margin-left: 8px;
          }
        }
      }
    }
  }
}
</style>
